module.exports = __webpack_public_path__ + "img/nodejs.eab8d5e3.png";